export function runAutonomousLoop({
  supervisorState,
  lastActionTime,
}) {
  if (!supervisorState) return null;

  const now = Date.now();

  const noResponse =
    lastActionTime && now - lastActionTime > 20000; // 20 sec demo

  if (
    supervisorState.stage === "awaitingOperator" &&
    noResponse
  ) {
    return {
      stage: "autoEscalate",
      message: "operatorDelayEscalating",
      actions: [
        "notifySecurityCommand",
        "lockZone",
        "activateCameraFocus",
      ],
    };
  }

  return null;
}
